const MissionDashboard = () =>
  import(
    /* webpackChunkName: "MissionDashboard" */
    "@/components/ssp/missions/mission/MissionDashboard.vue"
  );

const MissionIdentityCard = () =>
  import(
    /* webpackChunkName: "MissionIdentityCard" */
    "@/components/ssp/missions/mission/MissionIdentityCard.vue"
  );

import MissionIdentityCardChildren from "@/router/desktop/childrens/ssp/missions/childrens/mission-identity-card-childrens";

const MissionContributors = () =>
  import(
    /* webpackChunkName: "MissionContributors" */
    "@/components/ssp/missions/mission/MissionContributors.vue"
  );

const MissionIntervention = () =>
  import(
    /* webpackChunkName: "MissionIntervention" */
    "@/components/ssp/missions/mission/MissionIntervention.vue"
  );
const MissionInterpretation = () =>
  import(
    /* webpackChunkName: "MissionInterpretation" */
    "@/components/ssp/missions/mission/MissionInterpretation.vue"
  );
const MissionGlobalSynthesis = () =>
  import(
    /* webpackChunkName: "MissionGlobalSynthesis" */
    "@/components/ssp/missions/mission/MissionGlobalSynthesis.vue"
  );

const MissionPreparation = () =>
  import(
    /* webpackChunkName: "MissionPreparation" */
    "@/components/ssp/missions/mission/MissionPreparation.vue"
  );

import MissionPreparationChildren from "@/router/desktop/childrens/ssp/missions/childrens/mission-preparation-childrens";

const MissionDocument = () =>
  import(
    /* webpackChunkName: "MissionReportsList" */
    "@/components/ssp/missions/mission/MissionDocument.vue"
  );

const Site = () =>
  import(
    /* webpackChunkName: "Site" */
    "@/components/ssp/missions/mission/Site.vue"
  );

const Schema = () =>
  import(
    /* webpackChunkName: "Schema" */
    "@/components/ssp/missions/mission/Schema.vue"
  );

const MissionReportListView = () =>
  import(
    /* webpackChunkName: "MissionReportListView" */
    "@/components/ssp/missions/mission/MissionReportsListView.vue"
  );

const MissionConfig = () =>
  import(
    /* webpackChunkName: "MissionConfig" */
    "@/components/ssp/missions/mission/MissionConfig.vue"
  );

const MissionSupervision = () =>
  import(
    /* webpackChunkName: "MissionSupervision" */
    "@/components/ssp/missions/mission/MissionSupervision.vue"
  );

import MissionInterventionChildren from "@/router/desktop/childrens/ssp/missions/childrens/mission-intervention-childrens";
import MissionInterpretationChildren from "@/router/desktop/childrens/ssp/missions/childrens/mission-interpretation-children";
import MissionGlobalSynthesisChildren from "@/router/desktop/childrens/ssp/missions/childrens/mission-global-synthesis-children";
import getOrCreatePreparation from "@/router/middleware/getOrCreatePreparation";
import getCurrentDashboard from "@/router/middleware/getCurrentDashboard";

import MissionDocumentChildren from "@/router/desktop/childrens/ssp/missions/childrens/mission-document-childrens";
import MissionSiteChildrens from "@/router/desktop/childrens/ssp/missions/childrens/mission-site-childrens";
import MissionSchemaChildrens from "@/router/desktop/childrens/ssp/missions/childrens/mission-schema-children";
import MissionReportsListViewChildren from "@/router/desktop/childrens/ssp/missions/childrens/mission-reports-list-childrens";
// Import the necessary Pinia stores
import { useMissionStore } from "@/store/modules/mission";
export default [
  {
    path: "",
    name: "mission-dashboard",
    component: MissionDashboard,
    beforeEnter: (to, from, next) => {
      const missionStore = useMissionStore();
      getCurrentDashboard(missionStore)(to, from, next);
    },
  },
  {
    path: "identity-card",
    name: "identity-card",
    component: MissionIdentityCard,
    children: MissionIdentityCardChildren,
    redirect: { name: "case" },
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "preparation",
    name: "mission-preparation",
    component: MissionPreparation,
    children: MissionPreparationChildren,
    redirect: { name: "internalMaterial" },
    beforeEnter: getOrCreatePreparation,
  },
  {
    path: "intervention",
    name: "mission-intervention",
    component: MissionIntervention,
    children: MissionInterventionChildren,
    redirect: { name: "SurveysAndSamples" },
  },

  {
    path: "interpretation",
    name: "mission-interpretation",
    component: MissionInterpretation,
    redirect: { name: "InvestigationSynthesis" },
    children: MissionInterpretationChildren,
  },

  {
    path: "global-synthesis",
    name: "mission-global-synthesis",
    component: MissionGlobalSynthesis,
    children: MissionGlobalSynthesisChildren,
    redirect: { name: "ConclusionAndRecommandations" },
  },
  {
    path: "documents",
    name: "mission-documents",
    component: MissionDocument,
    children: MissionDocumentChildren,
    redirect: { name: "documents" },
  },
  {
    path: "contributors/:type?",
    name: "mission-contributors",
    component: MissionContributors,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "site",
    name: "site",
    component: Site,
    children: MissionSiteChildrens,
    redirect: { name: "cartography" },
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "schema",
    name: "schema",
    component: Schema,
    children: MissionSchemaChildrens,
    redirect: { name: "initial-conceptual-schema" },
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "reports-list-view",
    component: MissionReportListView,
    children: MissionReportsListViewChildren,
  },
  {
    path: "config",
    name: "mission-config",
    component: MissionConfig,
  },
  {
    path: "supervision",
    name: "mission-supervision",
    component: MissionSupervision,
  },
];
